import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {globales,funciones}                                 from '../../global';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Button                                                   from '@material-ui/core/Button';
import Icono                                                        from '../../components/Icono';
import Tooltip                                                      from '@material-ui/core/Tooltip';


let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
//var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;


const getRowId = row => row.ID_SECCION_CLIENTE;
const getRowId_dias = row => row.DIA;



/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

    const columns= [{name:'ID_SECCION_CLIENTE',title: 'ID_SECCION_CLIENTE'},
        {name:'CODIGO_CURSO',title: 'Código'},
        {name:'DESCRIPCION_CURSO',title: 'Descripción'},
        {name:'CREDITOS',title: 'U.V.'},
        {name:'NUMERO_SECCION',title: 'Sección'},
        {name:'INICIO',title: 'Inicio'},
        {name:'FIN',title: 'Fin'},
        {name:'GRUPO',title: 'Grupo'},
        {name:'ESTATUS',title: 'ESTATUS'},
        {name:'ESTATUS_ACADEMICO',title: 'ESTATUS_ACADEMICO'},
        {name:'ESTATUS_FINANCIERO',title: 'ESTATUS_FINANCIERO'},
        {name:'ESTADO',title: 'Estado'},
        {name:'ESTADO_PAGO',title: 'Financiero'},
        {name:'URL',title: 'URL'},
        {name:'MOODLE',title: ' '},
    ];

    const columns_dias= [{name:'DIA',title: 'Día'},
    {name:'AULA',title: 'Aula'},
    {name:'INICIO_DIA',title: 'Inicio'},
    {name:'FIN_DIA',title: 'Fin'},
    ];

    const defaultHiddenColumnNames= ['ID_SECCION_CLIENTE','ESTATUS','ESTATUS_ACADEMICO','ESTATUS_FINANCIERO','URL'];
    const defaultHiddenColumnNames_dias= [];

    const tableColumnExtensions= [
        { columnName: 'CODIGO_CURSO', wordWrapEnabled: false, align: 'center',width:150},
        { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: false, align: 'left',width:400},
        { columnName: 'CREDITOS', wordWrapEnabled: false, align: 'center',width:50},
        { columnName: 'NUMERO_SECCION', wordWrapEnabled: false, align: 'center',width:70},
        { columnName: 'INICIO', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'FIN', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'GRUPO', wordWrapEnabled: false, align: 'center',width:150},
        { columnName: 'ESTADO', wordWrapEnabled: false, align: 'center',width:150},
        { columnName: 'ESTADO_PAGO', wordWrapEnabled: false, align: 'center',width:150},
        { columnName: 'MOODLE', wordWrapEnabled: false, align: 'center',width:100},
    ];

    const tableColumnExtensions_dias= [
        { columnName: 'DIA', wordWrapEnabled: false, align: 'left',width:120},
        { columnName: 'AULA', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'INICIO_DIA', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'FIN_DIA', wordWrapEnabled: false, align: 'center',width:100},
    ];


/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Horarios_Alumno extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            rows_principal: [],
            rows_dias:      [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
        }

           
        const VirtualTable_cellComponent = (props) => {
            const { column }    = props;
            const {row}         = props;
            var color='green'

            if(row.ESTATUS==='C')
            color='red'
            else if(row.ESTATUS_FINANCIERO==='K')
            color='orange'
            else if(row.ESTATUS_ACADEMICO==='W')
            color='orange'
            else if(row.ESTATUS_FINANCIERO==='T')
            color='grey'

            if(column.name==='ESTADO'||column.name==='ESTADO_PAGO')
            return(
                <Table.Cell {...props}
                style={{
                    color: color, 
                    fontWeight: 'bold',        
                    padding: '0rem 0rem !important',margin: '0px',                 
                  }}
                />
            );

            if(column.name==='MOODLE' && row.URL!==null && row.URL!==undefined && row.URL!=='')
            {
                return(
                    <Table.Cell {...props} style={{padding: '0rem 0rem 0rem 0rem !important',}}>
                    <Tooltip title={"Campus Virtual"}>
                      <Button onClick={()=>{window.open(row.URL, '_blank')}} variant="outlined" color="primary"
                        style={{margin:0,padding:5}}>
                        <Icono icono='HomeWork' fontSize='small'/>
                      </Button>
                      </Tooltip>
                    </Table.Cell>
                    );
            }

            return(
                <Table.Cell {...props}
                style={{
                    color: color,                 
                    padding: '0rem 0rem !important',margin: '0px',                 
                  }}
                />
            );
        }

        const RowDetail= ({ row }) => {

            var rows_dias=[]
            var height='170px'

            rows_dias = this.state.rows.filter(grupo => grupo.ID_SECCION_CLIENTE === row.ID_SECCION_CLIENTE);
            
            if(rows_dias.length===1)
            height='86px'
            else if(rows_dias.length===2)
            height='120px'
            else if(rows_dias.length===3)
            height='150px'

            return(
                <div style={{position: 'relative', zIndex:10}}>
                <CustomTable
                    Columns={columns_dias}                                    
                    Rows={rows_dias}                                          
                    TableColumnExtensions={tableColumnExtensions_dias}
                    DefaultHiddenColumnNames={defaultHiddenColumnNames_dias}
                    getRowId = {getRowId_dias}
                    height={height}
                    enabledFilterRows= {false}
                    standarPlugin = { <TableRowsIndexer/> }
                    //VirtualTable_cellComponent={this.VirtualTable_cellComponent}
                    showSelectionColumn={false}
                />
                </div>
            )
        }

        this.VirtualTable_cellComponent=VirtualTable_cellComponent
        this.RowDetail=RowDetail
    }; //FIN CONSTRUCTORS

componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b)
            Request.get(`${ip}/Horariosalumno/obtener_horarios_alumno/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                var found
                var rows_principal=[]
                tmp.forEach(
                  function getCheck(item, index) {
                    found = rows_principal.find(grupo => grupo.ID_SECCION_CLIENTE === item.ID_SECCION_CLIENTE);
                if (found==null){
                    rows_principal.push(item);
                }
                else{
                  found=null;
                }
                })
                
                    _this.setState({ rows:tmp,rows_principal: rows_principal,heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable
                    }); 
                }
                else
                {
                    _this.setState({rows: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
            _this.actualizarbarra(true)
        })
    })
}

onExpandedRowDetailIdsChange = expandedRowIds =>
{
    var expandedRowIds2=[]

    if(expandedRowIds.length>1)
    expandedRowIds2=[expandedRowIds[1]]
    else
    expandedRowIds2=[expandedRowIds[0]]
    
    this.setState({ expandedRowIds:expandedRowIds2 });
};

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
      </Backdrop>
      <div ref={this.tablaRef} style={{background:'white',marginTop:15,marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
      <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows_principal}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            height={this.state.heightTableMain}
            ExpandedRowDetailIds = {this.state.expandedRowIds}
            onExpandedRowDetailIdsChange={this.onExpandedRowDetailIdsChange}
            enabledFilterRows= {false}
            RowDetail={this.RowDetail}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={this.VirtualTable_cellComponent}
            showSelectionColumn={false}
            columnWidths={tableColumnExtensions}
        />
      </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    